const cards = [
  {
    tag: "Healthcare Risk",
    title: "Healthcare",
    body:
      "PHI flowing through vendor AI models under BAAs that were not written to address AI-specific risk. One OCR inquiry changes everything.",
    consequence: "⚠ OCR penalties up to $1.9M per HIPAA violation category",
  },
  {
    tag: "Manufacturing Risk",
    title: "Manufacturing",
    body:
      "Proprietary process data and supplier intelligence inside AI systems with no security perimeter. IP exposure that has not been quantified yet.",
    consequence: "⚠ CMMC Level 2 non-compliance disqualifies DoD contracts",
  },
  {
    tag: "AI Builders Risk",
    title: "AI Application Builders",
    body:
      "Enterprise clients requiring a security report before signing. No report exists to answer them. The deal stalls.",
    consequence: "⚠ Unauditable AI blocks enterprise and regulated-sector deals",
  },
];

export default function ArqProblem() {
  return (
    <section className="bg-arq-surface1 py-20 md:py-[120px] px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center max-w-[820px] mx-auto mb-16">
          <div className="arq-label mb-6">The Reality</div>
          <h2 className="font-display font-semibold text-arq-text mb-8" style={{ fontSize: "clamp(28px, 4vw, 40px)", lineHeight: 1.2 }}>
            Most Organizations Deployed AI. Almost None Have Reviewed the Risk.
          </h2>
          <div className="space-y-5 text-arq-muted text-[17px] leading-[1.75] max-w-[720px] mx-auto text-left md:text-center">
            <p>
              In the last 18 months, AI scribes, ambient documentation tools, EHR-embedded
              assistants, and predictive operations systems went live across healthcare,
              manufacturing, and financial services.
            </p>
            <p>Vendor contracts were signed. BAAs were executed. Go-lives happened.</p>
            <p>
              What did not happen was a formal security review of what those AI systems actually
              expose: to regulators, to attackers, and to your board. That gap is not hypothetical.
              It is sitting in production right now.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {cards.map((c) => (
            <div key={c.title} className="arq-card p-8">
              <span className="arq-tag-risk mb-5 inline-block">{c.tag}</span>
              <h3 className="font-display text-[20px] font-semibold text-arq-text mb-3 mt-2">
                {c.title}
              </h3>
              <p className="text-arq-muted text-[15px] leading-[1.7]">{c.body}</p>
              <p className="text-[12px] font-mono text-arq-danger mt-3">{c.consequence}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
